import { createStore } from 'vuex'

export default createStore({
  state: {
    isAuthenticated: false,
    user: null
  },
  mutations: {
    setAuthenticated(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
    }
  },
  actions: {
    login(context, credentials) {
      // 登录操作并设置 isAuthenticated 和 user
      context.commit('setAuthenticated',{isAuthenticated:true});
      context.commit("setUser",credentials.name);
      context.commit("setToken",credentials.token);
    },
    logout(context) {
      // 退出登录操作并重置 isAuthenticated 和 user
    }
  }
})

